export interface ApplePayConfig {
  merchantId: string;
  certificate: string;
  privateKey: string;
  passphrase: string;
}
